import type { InsendioState } from './types';

const initialState: InsendioState = {
  cards: [],
  expiresAt: 0,
  modals: [],
};

export default initialState;
